import React from 'react';

import _ from 'lodash';
import moment, { Moment } from 'moment';

import { IRosterShift, IRosterWorker } from '../../types';
import { WorkerDetailsColumn } from './worker-details-column';
import { DayColumn } from './DayColumn';
import { NoShiftIndicator } from './no-shift-indicator';
import { ShiftSlotStatus } from 'utilities/enum-utils';
import { GoodTable } from '@good/ui/templates';
import { WorkerShiftCardList } from './worker-shift-card-list';
import { rosterConfig } from '../../roster-config';

interface WorkerItemRowProps {
  worker: IRosterWorker;
  shifts: IRosterShift[];
  days: Moment[];
}

export function WorkerItemRow({ worker, shifts, days }: WorkerItemRowProps) {
  const hasShifts = true; // TODO : Change this to detect whether there are any shifts in the current day range.
  const totalDuration = _.reduce(
    _.filter(
      shifts,
      (shift) =>
        shift.supportWorkerId === worker.supportWorkerId &&
        !_.find(
          [ShiftSlotStatus.CANCELLED, ShiftSlotStatus.CANCELLED_UNPAID],
          (filteredStatus) => shift.shiftSlotStatus === filteredStatus,
        ),
    ),
    (acc, item) => {
      return (
        acc + Number(moment.duration(moment(item.shiftEndDateTime).diff(moment(item.shiftStartDateTime))).asSeconds())
      );
    },
    0,
  );

  return (
    <GoodTable.Tr>
      <GoodTable.Td sticky bg={rosterConfig.grayColor}>
        <WorkerDetailsColumn totalDuration={totalDuration} worker={worker} />
      </GoodTable.Td>

      {!hasShifts && (
        <GoodTable.Td>
          <NoShiftIndicator type='worker' />
        </GoodTable.Td>
      )}

      {days.map((day, idx) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <GoodTable.Td key={idx}>
          <DayColumn content={<WorkerShiftCardList day={day} worker={worker} shifts={shifts} />} />
        </GoodTable.Td>
      ))}
    </GoodTable.Tr>
  );
}
